import React, {useRef} from "react";
import PreviewImg from "../atoms/PreviewImg";
import PreviewTitle from "../atoms/PreviewTitle";
import {useDispatch, useSelector} from "react-redux";
import {optionAction} from "../../../../redux/store";
import usePreviewColor from "../molecules/usePreviewColor";
import {Scrollbars} from "react-custom-scrollbars-2";
import {useShootingPoint} from "../../../../hooks/controller/useShootingPoint";
import ColorSelector from "../molecules/ColorSelector";

const ColorOptionDetail = ({
                             code,
                             colorItemObject,
                             stepObject,
                             selectedColorTab,
                             targetColorItem
                           }) => {
  const dispatch = useDispatch();
  const sendData = useSelector(state => state.optionWindow.CONFIG_DATA);
  const langData = useSelector(state => state.theme.langData);
  const colorTarget = colorItemObject.colorTarget;
  const codeKeyData = sendData[code];
  const scrollbarsRef = useRef();
  const {currentColor} = usePreviewColor(code, colorItemObject);

  const isSelectedTab = targetColorItem
    ? selectedColorTab?.colorTarget === colorItemObject?.colorTarget
    : true;

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    dispatch(optionAction.setSendDataRemove(code));
  };

  return (
    <div className={"option-h3"} data-expand={!!isSelectedTab} data-value={!!sendData[code]}>
      {isSelectedTab && (
        <>
          <div className={"option-value"}>
            <PreviewImg currentColor={currentColor} code={code} type={"COLOR"}/>
            <PreviewTitle title={colorItemObject[langData.langName]} currentColor={currentColor} type={"COLOR"}/>
            {sendData[code] && code.includes("PINSTRIPE") && (
              <button
                type="button"
                id={"delete_button"}
                className="option-value-init"
                onClick={handleDeleteClick}
              />
            )}
          </div>
          <Scrollbars ref={scrollbarsRef}>
            <ColorSelector
              code={code}
              codeKeyData={codeKeyData}
              stepObject={stepObject}
              colorTarget={colorTarget}
              colorItemObject={colorItemObject}
            />
          </Scrollbars>
        </>
      )}
    </div>
  );
}

export default ColorOptionDetail;
